<template>
  <v-row justify="start">
    <v-dialog
      v-model="dialog"
      persistent
      scrollable
      max-width="50%"
      @click:outside="$emit('close')"
      @keydown.esc="$emit('close')"
    >
      <v-card class="rounded_max hide_overflow" flat>
        <v-toolbar dense flat>
          <h3>{{ title }}</h3>
          <v-spacer></v-spacer>
          <v-btn fab x- small depressed @click="$emit('close')"
            ><v-icon small>mdi-close</v-icon></v-btn
          >
        </v-toolbar>
        <v-card-text class="px-2 pb-0">
          <v-container style="height: max-content" v-if="dataSet">
            <div v-if="dataSet.length">
              <v-expansion-panels>
                <v-expansion-panel
                  class="rounded-lg my-2"
                  v-for="(item, i) in dataSet"
                  :key="`sect_${i}`"
                  elevation="1"
                  :disabled="item.disabled"
                >
                  <v-expansion-panel-header class="pa-3">
                    <router-link
                      class="opener_name d-flex align-center pa-2"
                      :to="`/scholar/${item.user_id}`"
                    >
                      <v-avatar size="40" class="mr-2">
                        <img
                          :src="
                            item.profile_picture ? item.profile_picture : ava
                          "
                          class="obj_fit"
                          alt="isyan"
                        />
                      </v-avatar>
                      <div>
                        <div class="d-flex align-center">
                          <h3 style="color: #006341">{{ item.name }}</h3>
                        </div>
                        <p class="default_txt mt-2">
                          {{ item.no_tf ? item.no_tf : "-" }}
                        </p>
                      </div>
                    </router-link>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <div>
                      <v-checkbox
                        v-model="item.present"
                        label="Presence"
                        color="green"
                        hide-details
                        class="ma-0"
                      ></v-checkbox>
                      <div class="my-2">
                        <b>Score</b>
                        <v-card
                          class="pa-2 d-flex align-center jusitfy-center"
                          outlined
                          width="max-content"
                        >
                          <div class="d-flex align-center">
                            <input
                              type="tel"
                              class="input_score"
                              v-model="item.score"
                            />
                            <h4 style="color: #a2aaad">/100</h4>
                          </div>
                        </v-card>
                      </div>
                      <div class="my-2">
                        <b>Notes</b>
                        <v-textarea
                          hide-details
                          class="my-1 rounded"
                          rows="4"
                          background-color="#f6f6f6"
                          solo
                          flat
                          placeholder="Type here..."
                          auto-grow
                          v-model="item.notes"
                        ></v-textarea>
                      </div>
                      <div class="d-flex justify-end mt-2">
                        <v-btn
                          depressed
                          dark
                          class="text-capitalize"
                          color="var(--g)"
                          @click="giveReview(item)"
                        >
                          send
                        </v-btn>
                      </div>
                    </div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </div>
            <v-overlay
              :absolute="true"
              color="white"
              opacity="1"
              :value="loading"
            >
              <v-progress-circular
                indeterminate
                class="mr-2"
                color="#006341"
              ></v-progress-circular>
              <b class="color_default">Loading...</b>
            </v-overlay>
          </v-container>
        </v-card-text>
        <v-card-actions> </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "giveReviewSync",
  props: ["dialog", "title"],
  computed: {
    ...mapState({
      ava: (state) => state.ava,
    }),
  },
  data() {
    return {
      loading: false,
      finding: false,
      dataSet: [],
      page: 1,
      limit: 10,
      total: null,
      last_page: null,
      find: "",
      isEmpty: false,
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.loading = true;
      let instance = this.$route.params.idInstance;
      let data = {
        path: `manage/course/section/synchronus/list/report?course_synchronous_id=${instance}`,
      };
      this.$store
        .dispatch("course/getData", data)
        .then((data) => {
          this.getMember(data.data);
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
    getMember(review) {
      this.loading = true;
      this.isEmpty = false;
      let data = {
        path: `manage/course/member?course=${this.$route.params.idCourse}`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          if (data.member.data.length > 0) {
            this.dataSet = data.member.data;
            this.dataSet.forEach((el) => {
              el["present"] = false;
              el["notes"] = "";
              el["score"] = null;
            });
            if (review.length) {
              review.forEach((i) => {
                this.dataSet.forEach((el) => {
                  if (review.length) {
                    if (i.scholar_id == el.id) {
                      if (i.attendance == "presence") {
                        el["present"] = true;
                      } else {
                        el["present"] = false;
                      }
                      el["notes"] = i.notes;
                      el["score"] = i.score;
                      return;
                    }
                  }
                });
              });
            }
          } else {
            this.isEmpty = true;
          }
          this.loading = false;
        })
        .catch((err) => {
          this.$store.dispatch("notify", {
            msg: err.message,
            type: "error",
          });
          if (!err.data.length) {
            this.isEmpty = true;
          }
          this.loading = false;
        });
    },
    giveReview(item) {
      this.loading = true;
      let instance = this.$route.params.idInstance;
      let body = {
        course_synchronous_id: instance,
        scholar_id: item.id,
        attendance: item.present ? "presence" : "absence",
        score: item.score,
        notes: item.notes,
      };
      let data = {
        path: `manage/course/section/synchronus/update/report`,
        body: body,
      };
      this.$store
        .dispatch("user/postApi", data)
        .then((data) => {
          this.fetchData();
          this.$emit("fetch");
          this.loading = false;
          this.$store.dispatch("notify", {
            msg: data.message,
            type: "success",
          });
        })
        .catch((e) => {
          if (e.data) {
            var key = Object.keys(e.data.errors);
            var values = Object.values(e.data.errors);
            for (let i = 0; i < key.length; i++) {
              for (let j = 0; j < values[i].length; j++) {
                this.$toast.error(values[i][j]);
              }
            }
          } else {
            this.$store.dispatch("notify", {
              msg: e.message,
              type: "error",
            });
          }
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.input_score {
  width: 100px;
}
.input_score:focus {
  outline: none;
}
</style>
